import { render, staticRenderFns } from "./RecipeListItem.vue?vue&type=template&id=5c4e8b57&scoped=true&"
import script from "./RecipeListItem.vue?vue&type=script&lang=js&"
export * from "./RecipeListItem.vue?vue&type=script&lang=js&"
import style0 from "./RecipeListItem.vue?vue&type=style&index=0&id=5c4e8b57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4e8b57",
  null
  
)

export default component.exports